import { OUTLINE_WIDTH } from "../button/constants";
import { PADDING_HORIZONTAL, PADDING_VERTICAL } from "./constants";
export var getPadding = function getPadding(theme, isDismissable) {
  if (!isDismissable) {
    return [PADDING_VERTICAL, PADDING_HORIZONTAL];
  }

  var verticalPadding = Math.min(theme.space[PADDING_VERTICAL], OUTLINE_WIDTH);
  var rightPadding = Math.min(theme.space[PADDING_HORIZONTAL], OUTLINE_WIDTH);
  return [verticalPadding, rightPadding, verticalPadding, PADDING_HORIZONTAL];
};